import { SMSGetterTypes } from './types';

export const getters = {
    [SMSGetterTypes.GetStatus](state) {
        return state.status
    },
    [SMSGetterTypes.GetBalance](state) {
        return state.balance
    },
    [SMSGetterTypes.GetSenders](state) {
        return state.senders
    },
}